/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const EstimationGroupMethodMethod = {
    NotSpecified: 'NotSpecified',
    Estimated: 'Estimated',
    AsRead: 'AsRead',
} as const;
export type EstimationGroupMethodMethod = typeof EstimationGroupMethodMethod[keyof typeof EstimationGroupMethodMethod];

